import Image from "next/image";

/**
 * Mirrors the mark used across Dubu (dubu-fable-site, merchant dashboard): icon + wordmark
 * + product label. The icon is a 128px derivative of the shared 6000×6000 source. That
 * original is 804KB, which is absurd for a 32px header mark.
 */
const DubuLogo = ({ showText = true }: { showText?: boolean }) => (
  <div className="flex items-center gap-2">
    <Image
      src="/assets/dubu-icon.png"
      alt="Dubu"
      width={32}
      height={32}
      priority
      className="h-8 w-8 shrink-0 rounded-lg object-contain"
    />
    {showText && (
      <div className="leading-tight">
        <p className="text-sm font-bold tracking-tight text-fg">Dubu</p>
        <p className="text-[10px] font-medium uppercase tracking-widest text-fg-muted">Swap</p>
      </div>
    )}
  </div>
);

export default DubuLogo;
